import 'rxjs/Rx';
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Account } from 'src/app/model/account';
import { TbEnvironment } from 'src/app/model/environment';
import { throwError } from 'rxjs';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators/catchError';
import { UrlMaker } from 'src/app/commons/url-maker';
import { OperationResult } from '@tb/auth';

@Injectable({
    providedIn: 'root',
})
export class AccountService {
    accountCreateUrl = 'accountonfly';
    accountCreateUrlWithRedirect = 'accountonflyFromUrl';
    accountRoleAssociation = 'accountroleassociation';
    module: string;
    version: string;
    authorizationStored: string;
    constructor(@Inject('env') private env: TbEnvironment, private http: HttpClient) {}

    // --------------------------------------------------------------------------------
    CreateAccountOrJustAssociate(
        acconfly: Account,
        subKey: string,
        expirationdate: Date,
        userAsked4Create: boolean
    ): Observable<OperationResult> {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        var expDateString: string = 'default'; //stringa a caso che non verra parsata dal backend come una data valida e che interpretera' quindi come data di default (+100 anni)
        if (expirationdate) {
            let expDate = new Date(expirationdate);
            if (expDate) {
                //se mi e' stata indicata una data in fase di associazione
                //mi costruisco una stringa come voglio io a prescindere dal local, nel formato standard:
                //YYYY-M-D //(oppure MM  e DD, non paddo con zeri perchè viene interpretata lo stesso correttamente dall'api in c#)
                //T
                //hh:mm:ss
                //perche altrimenti poi una volta che arriva all'api confonde mese e giorno, imposto coattamente 23.59.59
                let yyyy: string = expDate.getFullYear().toString();
                let MM: string = (expDate.getMonth() + 1).toString(); //non chiedetemi perche ma il mese è zeroBased
                let dd: string = expDate.getDate().toString();
                expDateString = yyyy + '-' + MM + '-' + dd + 'T23:59:59';
            }
        }

        const url = new UrlMaker()
            .appendBaseUrl(this.env.settings.storeApiUrl)
            .appendSegment('accounts')
            .appendSegment('createandorassociate')
            .appendSegment(subKey)
            .appendSegment(userAsked4Create.toString())
            .appendParameter('expirationDate', expDateString)
            .toString();
        return this.http
            .post<OperationResult>(url, acconfly, { headers: headers })
            .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error in saveAccount')));
    }

    // --------------------------------------------------------------------------------
    //[HttpPost("api/accountonflyFromUrl")] --> [HttpPut("api/accountonflyFromUrl")] gwam-account
    createWithRedirect(account: Account, redirectUrl: string): Promise<OperationResult> {
        const url = new UrlMaker().appendBaseUrl(this.env.settings.storeApiUrl).appendSegment(this.accountCreateUrlWithRedirect).toString();

        return this.http
            .post<OperationResult>(url, {
                account,
                redirectUrl,
            })
            .toPromise();
    }

    // --------------------------------------------------------------------------------
    //[HttpPost("api/accountroleassociation")] gwam-account
    roleAssociation(accountName: string, role: string): Promise<OperationResult> {
        const url = new UrlMaker().appendBaseUrl(this.env.settings.storeApiUrl).appendSegment(this.accountRoleAssociation).toString();

        return this.http
            .post<OperationResult>(url, {
                accountName,
                role,
            })
            .toPromise();
    }

    // --------------------------------------------------------------------------------
    //[HttpPost("api/accounts")]
    saveAccount(body: Object, accountName: string): Observable<OperationResult> {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        const url = new UrlMaker().appendBaseUrl(this.env.settings.storeApiUrl).appendSegment('accounts').toString();
        return this.http
            .post<OperationResult>(url, body, { headers: headers })
            .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error in saveAccount')));
    }

    public CreateAccountObj(
        accountName: string,
        email: string,
        fullName: string,
        getBrowserCultureLang: string,
        authenticationProvider: string
    ) {
        let account = new Account();
        account.AccountName = accountName;
        account.Email = email;
        account.FullName = fullName;
        //todo: da cambiare con i dati che ci sono nel database
        if (getBrowserCultureLang === 'en-US') {
            account.RegionalSettings = 'en';
            account.Language = 'en';
        } else if (getBrowserCultureLang === 'it' || getBrowserCultureLang === 'it-IT' || getBrowserCultureLang === 'it-CH') {
            account.RegionalSettings = 'it-IT';
            account.Language = 'it-IT';
        } else {
            account.RegionalSettings = getBrowserCultureLang;
            account.Language = getBrowserCultureLang;
        }
        account.Confirmed = false;
        account.AuthenticationProvider = authenticationProvider;
        return account;
    }
}
